import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const ReasonInputDialog = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    onSubmit(reason);
    setReason("");
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reason for Visit</DialogTitle>
      <DialogContent>
        <TextField
          multiline
          fullWidth
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter reason for visit"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonInputDialog;
